import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import theme from '../theme.js';

const items = [
  'Rheumatoid Arthritis',
  'Cancer',
  'Infectious Pneumonia',
  'Sepsis',
  'Vaccine Response'
];

const UseCases = () => {
  const navigate = useNavigate();

  const handleCircleClick = (condition) => {
    // Navigate to AllModelsPage and pass the selected condition
    navigate('/models', { state: { preselectedCondition: condition } });
  };

  return (
    <Box
      component="section"
      sx={{
        px: { xs: 2, sm: 4, md: 8 },
        textAlign: 'center',
        backgroundColor: 'rgba(20,36,52,0.05)',
        borderTop: '0.5px solid #142434',
        borderBottom: '0.5px solid #142434',
        pt: '40px',
        pb: '40px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 400,
          fontSize: '32px',
          color: '#142434',
          mb: 4,
        }}
      >
        Are you looking for anything in particular?
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '16px', sm: '24px', md: '32px' },
          flexWrap: 'wrap',
          mb: 3,
        }}
      >
        {items.map((label) => (
          <Box
            key={label}
            sx={{
              width: '120px',
              height: '120px',
              fontSize: '16px',
              borderRadius: '50%',
              backgroundColor: '#ffffff',
              border: '2px solid #489596',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              color: '#489596',
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': {
                transform: 'scale(1.05)',
              },
              [theme.breakpoints.up('ml')]: {
                width: '160px',
                height: '160px',
                fontSize: '20px',
              },
            }}
            onClick={() => handleCircleClick(label)}
          >
            {label}
          </Box>
        ))}
      </Box>

      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 400,
          fontSize: '18px',
          color: '#142434',
        }}
      >
        Or looking for{' '}
        <Link
          href="/models"
          sx={{
            textDecoration: 'underline',
            color: '#489596',
            fontWeight: 400,
          }}
        >
          something else
        </Link>
        ?
      </Typography>
    </Box>
  );
};

export default UseCases;
